/* -------------------------------------------------------------------------- */
/*                                  Constants                                 */
/* -------------------------------------------------------------------------- */

// Quick prompt shortcuts (prompts are in English for the AI)
export const QUICK_PROMPTS = [
  {
    key: 'removeExtensions',
    labelKey: 'Resource:DialogResourceEdit.quickPrompts.removeExtensions',
    exampleBefore: 'report.pdf',
    exampleAfter: 'report',
    prompt:
      'Remove the file extension from each file name. Do not change anything else about the file name. Keep all characters, spacing, punctuation, and capitalization exactly the same, only delete the extension.',
  },
  {
    key: 'removeIndexNumbers',
    labelKey: 'Resource:DialogResourceEdit.quickPrompts.removeIndexNumbers',
    exampleBefore: '01 - M&A report',
    exampleAfter: 'M&A report',
    prompt:
      "Remove an index number only when it appears at the very beginning of a file name. An index number is defined as: one or more digits, followed by a dot, followed by one or more digits, followed by a space. Example pattern: '3.5', '4.10', '12.2'. Do not change any other part of the file name. Keep spacing, punctuation, and capitalization, brackets, exactly the same except for deleting these indexes",
  },
  {
    key: 'removeCopySuffixes',
    labelKey: 'Resource:DialogResourceEdit.quickPrompts.removeCopySuffixes',
    exampleBefore: 'HR Agreement - Copy (2)',
    exampleAfter: 'HR Agreement',
    prompt:
      "Remove any copy/duplicate suffixes that operating systems automatically add when copying or duplicating files. This includes patterns like: '(1)', '(2)', '- Copy', 'Copy of', ' copy', ' copy 2', ' 2', '(copy)', '(another copy)', and similar variations. Only remove these system-generated suffixes, do not change anything else about the file name. Keep all other characters, spacing, punctuation, and capitalization exactly the same.",
  },
  {
    key: 'renameFromContent',
    labelKey: 'Resource:DialogResourceEdit.quickPrompts.renameFromContent',
    exampleBefore: 'Document_scan_003',
    exampleAfter: 'Q4 Financial Report',
    prompt:
      'Rename this file based on its content. Create a clear, descriptive name that reflects what the document is about. Keep it concise but informative.',
  },
] as const;
